import { FlaskConical } from 'lucide-react';
import { useAuthStore } from '../../../store/authStore';
import { HMRC_SANDBOX_TOOLS_TENANT_ID } from './constants';
import HmrcSandboxTestUser from './HmrcSandboxTestUser';

/**
 * HMRC Sandbox Tools — dev tenant only. Renders nothing when access conditions are not met.
 */
export default function HmrcSandboxTools({ isAdmin }) {
  const getTenantId = useAuthStore((s) => s.getTenantId);

  if (!isAdmin) return null;
  if (getTenantId() !== HMRC_SANDBOX_TOOLS_TENANT_ID) return null;

  return (
    <div className="space-y-4 pt-4 border-t border-[var(--ds-border-subtle)]">
      <div>
        <h3 className="text-h2 font-semibold text-[var(--ds-text-primary)] flex items-center gap-2">
          <FlaskConical className="h-5 w-5 text-[var(--ds-accent-primary)]" aria-hidden />
          HMRC Sandbox Tools
        </h3>
        <p className="text-micro text-[var(--ds-text-muted)] mt-1">
          Sandbox-only utilities for HMRC development and testing. These tools never apply to the live HMRC
          environment.
        </p>
      </div>

      <div className="rounded-[var(--ds-radius-md)] border border-[var(--ds-border-subtle)] bg-[var(--ds-surface-panel)] p-4">
        <h4 className="text-meta font-semibold text-[var(--ds-text-primary)] mb-1">Create Test User</h4>
        <p className="text-micro text-[var(--ds-text-muted)] mb-4">
          Generate HMRC sandbox credentials via the Create Test User API. Credentials are returned once and are not
          stored by SparxMate.
        </p>
        <HmrcSandboxTestUser />
      </div>
    </div>
  );
}
